import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../services/auth.service';
import { UsuarioLoginRequest } from '../../models/usuarioLoginRequest';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '../../services/toast.service';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { LoginHelper } from '../../helpers/login.helper';
import { SpinnerService } from '../../services/spinner.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  formLogin = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    rememberMe: new FormControl(false, []),
  });

  isSubmitting = false;

  constructor(
    private cookieService: CookieService,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private loginHelper: LoginHelper,
    private spinnerService: SpinnerService,
  ) { }

  ngOnInit() {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      if (params.get('session') === 'expired') {
        this.toastService.setMensagemToast(
          'Sua sessão expirou ou não é mais válida. Faça login novamente para continuar.',
          SeveridadeToast.Warn,
        );
        void this.router.navigate(['/login'], { replaceUrl: true });
      }
    });

    this.spinnerService.show('Carregando página inicial...')
    if (this.loginHelper.get()) {
      this.router.navigate(['/home']);
      this.spinnerService.hide();
    }
    if (this.isChecked()) {
      this.formLogin.controls.rememberMe.setValue(this.isChecked());
      this.formLogin.controls.email.setValue(this.cookieService.get('email'));
      this.formLogin.controls.password.setValue(this.cookieService.get('password'));
    }
    this.spinnerService.hide();
  }

  onSubmit(): void {
    if (this.formLogin.invalid) { return; }

    this.isSubmitting = true;
    const usuarioLogin: UsuarioLoginRequest = {
      email: this.formLogin.controls.email.value!,
      senha: this.formLogin.controls.password.value!
    };

    this.spinnerService.show('Autenticando...');
    this.authService.usuarioLoginRequest(usuarioLogin).subscribe({
      next: () => {
        if (this.formLogin.controls.rememberMe.value) {
          this.cookieService.set('email', usuarioLogin.email, { expires: 30 });
          this.cookieService.set('password', usuarioLogin.senha, { expires: 30 });
        } else {
          this.cookieService.delete('email');
          this.cookieService.delete('password');
        }
        this.toastService.setMensagemToast('Login realizado com sucesso!', SeveridadeToast.Success);
        this.router.navigate(['/home']);
        this.spinnerService.hide();
        this.isSubmitting = false;
      },
      error: (e: HttpErrorResponse) => {
        const errorMessage = e.error?.message
          ? `Erro: ${e.error.message}`
          : 'Credenciais incorretas. Por favor, tente novamente.';
        this.toastService.setMensagemToast(errorMessage, SeveridadeToast.Error);
        this.spinnerService.hide();
        this.isSubmitting = false;
      }
    });
  }

  isChecked(): boolean {
    return this.cookieService.get('rememberMe') !== '';
  }

  redirectTo(route: string) {
    this.router.navigateByUrl(route);
  }

  get form(): any {
    return this.formLogin.controls;
  }

  navigateToCadastro() {
    this.router.navigate(['/cadastro']);
  }
  navigateToForgotPassword() {
    this.router.navigate(['/forgot-password']);
  }
}
